export default {"src":"/_next/static/media/DiabeticRetinopathy.8102d808.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};